export const executeAfterConfig = ({ limitTime, onLimitTime, webSocketRef, }) => {
    if (limitTime) {
        return {
            limitTime,
            onLimitTime: async () => {
                await onLimitTime?.();
                if (webSocketRef.current) {
                    const connectedWebsocket = webSocketRef.current;
                    webSocketRef.current = null;
                    return connectedWebsocket.disconnect();
                }
            },
        };
    }
    return {
        limitTime: undefined,
        onLimitTime: undefined,
    };
};
//# sourceMappingURL=useWebSocket.configuration.js.map